'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mountScript(url) {
    var head = document.getElementsByTagName('head')[0];

    if (!head.querySelector('script[src="' + url + '"]')) {
        var script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.src = url;
        head.appendChild(script);
    }
}

exports.default = function (variable, url) {
    return new Promise(function (resolve, reject) {
        var checkInterval = 50;
        var checkTimeout = 5000;
        var intervalId = void 0;
        var timeoutId = void 0;

        if ((0, _get3.default)(window, variable)) {
            resolve();
        } else {
            mountScript(url);

            // Checking for variable exists
            intervalId = setInterval(function () {
                if ((0, _get3.default)(window, variable)) {
                    clearInterval(intervalId);
                    clearTimeout(timeoutId);

                    resolve();
                }
            }, checkInterval);

            // Showing error if variable doesn't exist for a while
            timeoutId = setTimeout(function () {
                clearInterval(intervalId);
                console.error('Cannot load "' + url + '"');
                reject();
            }, checkTimeout);
        }
    });
};